var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwitterinline = function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "#259DF4",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.355 9.043a4.61 4.61 0 0 1-1.262.326c.454-.256.802-.663.966-1.147a4.55 4.55 0 0 1-1.396.503 2.26 2.26 0 0 0-1.604-.655c-1.214 0-2.198.929-2.198 2.075 0 .162.02.32.057.471-1.828-.086-3.447-.912-4.531-2.166a1.983 1.983 0 0 0-.298 1.042c0 .72.389 1.354.978 1.726-.36-.01-.7-.104-.996-.26v.027c0 1.005.758 1.843 1.764 2.034a2.339 2.339 0 0 1-.993.035c.28.824 1.091 1.424 2.054 1.44-.753.556-1.701.888-2.73.888a4.76 4.76 0 0 1-.525-.029 6.49 6.49 0 0 0 3.369.932c4.044 0 6.254-3.16 6.254-5.9a5.57 5.57 0 0 0-.006-.268c.43-.293.802-.657 1.096-1.073v-.001Z",
    fill: "#fff"
  })));
};
export default SvgTwitterinline;